import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormInputText from '../../../../../common/Forms/FormTextField';
import { useDispatch } from 'react-redux';
import {
  setCommPhone,
  setCommFax,
  setCommEmail,
  setCommWeb,
} from '../../../../../../redux/organization/organizationTabs/addressAndContacts/addressAndContactsSlice';

const Communications = (props) => {
  const dispatch = useDispatch();
  const { control, register, errors } = props;

  return (
    <>
      <Typography
        variant='h5'
        style={{ marginBottom: '-10px', marginTop: '-10px' }}
      >
        Communications :
      </Typography>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='commPhone'
            type='text'
            control={control}
            errors={!!errors.commPhone}
            helperText={errors?.commPhone?.message}
            label='Phone'
            register={register('commPhone', {
              onChange: (e) => dispatch(setCommPhone(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='commFax'
            type='text'
            control={control}
            errors={!!errors.commFax}
            helperText={errors?.commFax?.message}
            label='Fax'
            register={register('commFax', {
              onChange: (e) => dispatch(setCommFax(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='commEmail'
            type='text'
            control={control}
            errors={!!errors.commEmail}
            helperText={errors?.commEmail?.message}
            label='Email'
            register={register('commEmail', {
              onChange: (e) => dispatch(setCommEmail(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='commWeb'
            type='text'
            control={control}
            errors={!!errors.commWeb}
            helperText={errors?.commWeb?.message}
            label='Web'
            register={register('commWeb', {
              onChange: (e) => dispatch(setCommWeb(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Communications;
